import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight, Phone } from "lucide-react";
import { motion } from "framer-motion";
import SEOHead from "../components/SEOHead";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

/**
 * Page 404 — servie pour toute URL inconnue.
 * Émet une meta noindex explicite pour éviter l'indexation.
 *
 * NB: sur un hébergement 100 % statique, l'HTTP status renvoyé pour cette
 * page dépend de la config d'hébergement. Un `404.html` racine (convention
 * Netlify, Cloudflare Pages, GitHub Pages, GCS static) est fourni en
 * complément afin que les hébergeurs qui la respectent servent bien un
 * vrai 404.
 */
export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="bg-[#050505] text-white min-h-screen flex flex-col"
    >
      <SEOHead
        title="Page introuvable — GMC Rénovation Façade"
        description="La page demandée n'existe pas. Retournez à l'accueil de GMC Rénovation Façade pour découvrir nos prestations de ravalement à Valenciennes."
        path="/404"
        noindex
      />
      <Nav />
      <main className="flex-1 flex items-center justify-center px-6 py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-xl text-center"
        >
          <div className="eyebrow mb-6 inline-flex items-center gap-2">
            <span>Erreur 404</span>
          </div>
          <h1 className="font-display text-6xl md:text-7xl lg:text-8xl font-light leading-none mb-6">
            <span className="text-[#FF5A00]">404</span>
          </h1>
          <p className="font-display text-2xl md:text-3xl text-white mb-4 leading-tight">
            Cette page n&apos;existe pas
          </p>
          <p className="text-neutral-400 text-base mb-10 leading-relaxed">
            La page que vous cherchez a peut-être été déplacée ou n&apos;a jamais existé.
            Retournez à l&apos;accueil ou contactez-nous directement.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="btn-primary justify-center text-base px-6 py-3.5"
            >
              <HomeIcon size={16} /> Retour à l&apos;accueil <ArrowRight size={16} />
            </Link>
            <a
              href="tel:+33763433867"
              data-testid="not-found-phone-btn"
              className="btn-ghost justify-center"
            >
              <Phone size={16} /> 07 63 43 38 67
            </a>
          </div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
